// import React, { useState, useEffect } from "react";
// import { ShimmerTable } from "react-shimmer-effects";
// import moment from "moment";
// import { Table, Button, Row, Col } from "react-bootstrap";
// import schoolApi from "../../api/schoolApi";
// import {
//   DatatableWrapper,
//   Pagination,
//   TableBody,
//   TableHeader,
// } from "react-bs-datatable";
// import { toast } from "react-toastify";

// function Parents(parentId) {
//   const [parentBody, setParentBody] = useState([]);
//   const header = [
//     {
//       title: "PARENT NAME",
//       prop: "contactname",
//       isFilterable: true,
//     },
//     { title: "Profession", prop: "profession" },
//     { title: "Qualification", prop: "qualification", isFilterable: true },
//     { title: "Phone", prop: "phone", isFilterable: true },
//     { title: "Email", prop: "email", isFilterable: true },
//   ];

//   useEffect(() => {
//     fetchContact();
//   }, []);

//   const fetchContact = async () => {
//     let parent_id = parentId.parentid
//     if (parent_id !== null) {
//       try {
//         const result = await schoolApi.fetchContact(parent_id);
//         if (result?.contactRec) {
//           setParentBody([result?.contactRec]);
//         } else {
//           setParentBody([]);
//         }
//       } catch (error) {
//         toast.error(error?.response?.data?.message);
//       }
//     }
//   };

//   return (
//     <div>
//       <Row className="mt-2">
//         <Col lg={12}>
//           {parentBody ? (
//             parentBody.length > 0 ? (
//               <DatatableWrapper body={parentBody} headers={header}>
//                 <Table striped className="data-table custom-table-subject-list">
//                   <TableHeader />
//                   <TableBody />
//                 </Table>
//                 <Pagination />
//               </DatatableWrapper>
//             ) : (
//               <div>
//                 <DatatableWrapper body={parentBody} headers={header}>
//                   <Table
//                     striped
//                     className="data-table custom-table-subject-list"
//                   >
//                     <TableHeader />
//                     <TableBody>
//                       <tr>
//                         <td colSpan={header.length} className="text-center">
//                           No Records Found!!!
//                         </td>
//                       </tr>
//                     </TableBody>
//                   </Table>
//                   <Pagination />
//                 </DatatableWrapper>
//               </div>
//             )
//           ) : (
//             <ShimmerTable row={10} col={8} />
//           )}
//         </Col>
//       </Row>
//     </div>
//   );
// }

// export default Parents;



import React, { useState, useEffect } from "react";
import { ShimmerTable } from "react-shimmer-effects";
import moment from "moment";
import { Table, Button, Row, Col, Dropdown } from "react-bootstrap";
import schoolApi from "../../api/schoolApi";
import {
  DatatableWrapper,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { toast } from "react-toastify";

function Parents(parentId) {
  const [parentBody, setParentBody] = useState([]);
  const baseHeader = [
    {
      title: "PARENT NAME",
      prop: "contactname",
      isFilterable: true,
    },
    { title: "Profession", prop: "profession" },
    { title: "Qualification", prop: "qualification", isFilterable: true },
    { title: "Phone", prop: "phone", isFilterable: true },
    { title: "Email", prop: "email", isFilterable: true },
  ];

  // Manage visible columns
  const [headers, setHeaders] = useState(
    baseHeader.map((h) => ({ ...h, visible: true }))
  );

  const toggleColumn = (prop) => {
    setHeaders((prev) =>
      prev.map((h) => (h.prop === prop ? { ...h, visible: !h.visible } : h))
    );
  };

  useEffect(() => {
    fetchContact();
  }, []);

  const fetchContact = async () => {
    let parent_id = parentId.parentid
    if (parent_id !== null) {
      try {
        const result = await schoolApi.fetchContact(parent_id);
        if (result?.contactRec) {
          setParentBody([result?.contactRec]);
        } else {
          setParentBody([]);
        }
      } catch (error) {
        toast.error(error?.response?.data?.message);
      }
    }
  };

  return (
    <div>
      <Row className="mt-2">
        <Col lg={12}>
              {parentBody ? (
            parentBody.length > 0 ? (
              <>
                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
                  <Dropdown align="end">
                    <Dropdown.Toggle variant="light" id="columns-dropdown">
                      Columns
                    </Dropdown.Toggle>

                    <Dropdown.Menu style={{ minWidth: 220, padding: 10 }}>
                      <h6 style={{ marginBottom: 10 }}>Show / Hide Columns</h6>
                      {headers.map((col, idx) => (
                        <div key={idx} style={{ padding: "6px 4px" }}>
                          <input
                            type="checkbox"
                            checked={col.visible}
                            onChange={() => toggleColumn(col.prop)}
                            id={`col-toggle-${col.prop}`}
                          />
                          <label htmlFor={`col-toggle-${col.prop}`} style={{ marginLeft: 8 }}>
                            {col.title}
                          </label>
                        </div>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <DatatableWrapper body={parentBody} headers={headers.filter((h) => h.visible)}>
                  <Table striped className="data-table custom-table-subject-list">
                    <TableHeader />
                    <TableBody />
                  </Table>
                  <Pagination />
                </DatatableWrapper>
              </>
            ) : (
              <div>
                <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 8 }}>
                  <Dropdown align="end">
                    <Dropdown.Toggle variant="light" id="columns-dropdown-empty">
                      Columns
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ minWidth: 220, padding: 10 }}>
                      <h6 style={{ marginBottom: 10 }}>Show / Hide Columns</h6>
                      {headers.map((col, idx) => (
                        <div key={idx} style={{ padding: "6px 4px" }}>
                          <input
                            type="checkbox"
                            checked={col.visible}
                            onChange={() => toggleColumn(col.prop)}
                            id={`col-toggle-empty-${col.prop}`}
                          />
                          <label htmlFor={`col-toggle-empty-${col.prop}`} style={{ marginLeft: 8 }}>
                            {col.title}
                          </label>
                        </div>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <DatatableWrapper body={parentBody} headers={headers.filter((h) => h.visible)}>
                  <Table
                    striped
                    className="data-table custom-table-subject-list"
                  >
                    <TableHeader />
                    <TableBody>
                      <tr>
                        <td colSpan={Math.max(1, headers.filter((h) => h.visible).length)} className="text-center">
                          No Records Found!!!
                        </td>
                      </tr>
                    </TableBody>
                  </Table>
                  <Pagination />
                </DatatableWrapper>
              </div>
            )
          ) : (
            <ShimmerTable row={10} col={8} />
          )}
        </Col>
      </Row>
    </div>
  );
}

export default Parents;
